module.exports = __webpack_public_path__ + "0905747f1810fa8f1fc7bf30a84d22f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/gerichte.svg
// module id = 8
// module chunks = 0